import { getPathDatabaseByRole } from "../actions/auth";
import { useDispatchApp, useSelectorApp } from "../lib/redux";

/**
 * True when `agenciesFeatureFlags/animateImageWithPrompt` includes the current agency.
 * The animate-image flow then asks for an optional prompt before launching.
 */
const useAgencyHasAnimateImageWithPromptFeature = () => {
  const dispatch = useDispatchApp();
  const { agencyID } = dispatch(getPathDatabaseByRole());
  const agencies = useSelectorApp(
    (state) => state.ui.agenciesFeatureFlags?.animateImageWithPrompt ?? []
  );

  return Boolean(agencyID) && agencies.includes(agencyID);
};

export default useAgencyHasAnimateImageWithPromptFeature;
